import { render, staticRenderFns } from "./rangerule.vue?vue&type=template&id=5c85b7dc&"
import script from "./rangerule.vue?vue&type=script&lang=js&"
export * from "./rangerule.vue?vue&type=script&lang=js&"
import style0 from "./rangerule.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports